function OutboundPlanIcon(props) {
  const { isActive } = props
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3333 0.333344H0.333334V4.33334H12.3333V0.333344ZM11 3.00001H1.66667V1.66668H11V3.00001ZM9.66667 5.00001C8.79333 5.00001 7.97333 5.24668 7.27333 5.66668H4.66667C4.48 5.66668 4.33333 5.81334 4.33333 6.00001V7.00001H5.84C5.2917 7.78101 4.9983 8.71243 5 9.66668C5 10.1333 5.07333 10.58 5.19333 11H2.33333V5.00001H1V12.3333H5.84C6.68667 13.54 8.08 14.3333 9.66667 14.3333C12.2467 14.3333 14.3333 12.2467 14.3333 9.66668C14.3333 7.08668 12.2467 5.00001 9.66667 5.00001ZM9.66667 13C7.82667 13 6.33333 11.5067 6.33333 9.66668C6.33333 7.82668 7.82667 6.33334 9.66667 6.33334C11.5067 6.33334 13 7.82668 13 9.66668C13 11.5067 11.5067 13 9.66667 13ZM10 9.83334L11.9067 10.96L11.4067 11.7733L9 10.3333V7.00001H10V9.83334Z"
        fill={!isActive ? '#828282' : '#FFFFFF'}
      />
    </svg>
  )
}

export default OutboundPlanIcon
